export default "__VITE_ASSET__BApr2CEi__"